export const CReminderDownloadAPP = {
    SRC_IMAGE: "qr_download_app_modak.webp",
    FILE_NAME: "qr_download_app_modak.webp",
    PATH_QR_IMAGE : "qr_download_app_modak.webp",
    LINK_QR_MOBILE_APP : "https://modak.go.link/?adj_t=14g88cdd_14exme9v"
} as const;